import { type ReactNode } from "react";
import { Outlet } from "react-router";
import { AuthHeader } from "./AuthHeader";

interface AuthLayoutProps {
  children?: ReactNode;
}

export function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="min-h-screen min-h-dvh flex flex-col w-full overflow-x-clip bg-background text-foreground antialiased selection:bg-primary/20 selection:text-primary">
      <AuthHeader />
      <main id="main-content" className="flex-1 flex flex-col w-full min-w-0">
        {children ?? <Outlet />}
      </main>
      <footer className="py-4 border-t border-border/40 text-center text-xs text-muted-foreground bg-background/60 backdrop-blur-sm z-10">
        <div className="container">
          &copy;&nbsp;2026&nbsp;Bloxida. All rights reserved.
        </div>
      </footer>
    </div>
  );
}
